(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["global-scripts"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.add('js');
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  });
  document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input');
    wrapper.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = Number(button.dataset.delta);
        input.value = Math.max(Number(input.min || 1), Number(input.value) + delta);
      });
    });
  });
  document.querySelectorAll('[data-variant-options]').forEach((options) => {
    const section = options.closest('[data-product-section]');
    const form = options.closest('form');
    const variants = JSON.parse(form.querySelector('[data-product-variants]').textContent);
    const variantInput = form.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const button = section.querySelector('[data-add-button]');
    options.addEventListener('change', () => {
      const selected = [...options.querySelectorAll('fieldset')].map((fieldset) => fieldset.querySelector('input:checked')?.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      variantInput.value = variant.id;
      price.textContent = variant.price;
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.addLabel : button.dataset.soldLabel;
      if (variant.imageId) {
        section.querySelector('[data-product-carousel]')?.dispatchEvent(new CustomEvent('variant:image', { detail: { imageId: variant.imageId } }));
      }
      if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    });
  });
  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
    const thumbnails = [...carousel.querySelectorAll('[data-carousel-thumbnail]')];
    const counter = carousel.querySelector('[data-carousel-current]');
    let active = 0;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== active; });
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const selected = thumbnailIndex === active;
        thumbnail.classList.toggle('is-active', selected);
        thumbnail.setAttribute('aria-pressed', String(selected));
      });
      if (counter) counter.textContent = String(active + 1);
    };
    carousel.querySelector('[data-carousel-previous]')?.addEventListener('click', () => show(active - 1));
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => show(active + 1));
    thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => show(Number(thumbnail.dataset.carouselThumbnail))));
    carousel.addEventListener('variant:image', (event) => {
      const imageId = String(event.detail.imageId);
      const imageIndex = slides.findIndex((slide) => slide.dataset.carouselImageId === imageId);
      if (imageIndex >= 0) show(imageIndex);
    });
    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(active - 1);
      if (event.key === 'ArrowRight') show(active + 1);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
